import api from './api';

export default {
  getAll() { return api.get('/customers'); },
  getById(id: number) { return api.get(`/customers/${id}`); },
  create(data: any) { return api.post('/customers', data); },
  update(id: number, data: any) { return api.put(`/customers/${id}`, data); },
  delete(id: number) { return api.delete(`/customers/${id}`); }
};
